<template lang="pug">
    v-form(ref="additionalForm" id="additionalForm" @submit.prevent="doSave" lazy-validation)
        v-container(grid-list-md)
            v-layout(wrap)
                v-flex(lg2 md2 xs12)
                    v-text-field(dense v-model="data.key" :rules="[v => !!v || 'Input Key']" label="Key" required :readonly="isUpdate")
                v-flex(lg8 md8 xs12)
                    v-text-field(dense v-model="data.value" :rules="[v => !!v || 'Input Value']" label="Value" required)
            div(justify-center style="text-align: center" class="ma-2 menu-btn")
                v-btn(class="mx-1" @click="doCancel") Kembali
                    v-icon mdi-arrow-left
                v-btn(color="btnprimary white--text" class="mx-1" type="submit" form="additionalForm") Simpan
                    v-icon mdi-content-save-outline    
</template>
<script>
export default {
    name: "FAdditionalDataForm",
    props: ["additional","isUpdate"],
    data() {
        return {
            data: {
                key: "",
                value: ""
            }
        }
    },
    watch: {
        additional(val){
            this.doInitModel(val);
        }
    },
    mounted() {
        this.doInitModel(this.additional);
    },
    methods: {
        doInitModel(values){
            if(this.$refs.additionalForm){
                this.$refs.additionalForm.resetValidation();
            }
            this.data = values ? values : {
                key: "",
                value: ""
            }
        },
        doSave(){
            if(this.$refs.additionalForm.validate()){
                if(this.isUpdate){
                    this.$emit("update", this.data);
                }else{
                    this.$emit("save", this.data);
                }
            }
        },
        doCancel(){
            this.$emit("cancel");
        }
    }
}
</script>